/** Presents an organized, responsive Liquid Glass footer with the original line-icon language. */
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  ArrowRight02Icon,
  ArrowUpRight01Icon,
  GithubIcon,
  Linkedin02Icon,
  Mail01Icon,
} from '@hugeicons/core-free-icons';
import { usePortfolio } from '../../../features/portfolio/presentation/context/PortfolioContext';
import { Reveal } from '../ui/Reveal';

export function Footer() {
  const { data } = usePortfolio();
  const { profile } = data;
  const { copy, footerPages } = data.siteContent;

  const socials = [
    { label: 'GitHub', href: profile.githubUrl || 'https://github.com/the-razib', icon: GithubIcon },
    { label: 'LinkedIn', href: profile.linkedinUrl || 'https://linkedin.com/in/labibur', icon: Linkedin02Icon },
    { label: 'Email', href: `mailto:${profile.email}`, icon: Mail01Icon },
  ].filter((item) => item.href);

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-grid">
          <Reveal className="footer-intro" direction="lightSpeedInLeft">
            <Link className="footer-brand" to="/">
              <span className="footer-brand-mark" aria-hidden="true">
                {profile.logoUrl ? <img src={profile.logoUrl} alt="" /> : 'LB'}
              </span>
              <strong>{profile.brandName}</strong>
            </Link>
            <p className="footer-title-subtitle">{profile.title}</p>
            <Link className="button button-primary button-dark button-small footer-cta-btn" to="/contact">
              <HugeiconsIcon icon={Mail01Icon} size={14} /> {copy.footerButton}
            </Link>
          </Reveal>

          <Reveal direction="fadeInUpBig" delay={0.12}>
            <nav aria-label="Footer pages">
              <p className="footer-heading">{copy.footerPagesTitle}</p>
              <ul className="footer-links">
                {footerPages.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href}>
                      <HugeiconsIcon icon={ArrowRight02Icon} size={12} className="footer-link-arrow" /> <span>{link.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </Reveal>

          <Reveal direction="fadeInUpBig" delay={0.24}>
            <p className="footer-heading">{copy.footerSocialTitle}</p>
            <ul className="footer-links footer-social-links">
              {socials.map(({ label, href, icon }) => (
                <li key={label}>
                  <a href={href} target={href.startsWith('mailto:') ? undefined : '_blank'} rel="noreferrer">
                    <span className="footer-social-left">
                      <HugeiconsIcon icon={icon} size={15} />
                      <span>{label}</span>
                    </span>
                    <HugeiconsIcon icon={ArrowUpRight01Icon} size={11} className="footer-social-arrow" />
                  </a>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">© {new Date().getFullYear()} {profile.brandName}</p>
          <p className="footer-credit">
            <span>Made with</span> <Heart size={11} fill="currentColor" className="footer-heart-icon" /> <span>using React & Firebase</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
